export default function About() {
  return (
    <section id="about" className="py-16 px-6 bg-white reveal">
      <div className="max-w-6xl mx-auto">

        <h2 className="text-3xl font-bold text-center mb-6">
          About Venkata Sai Traders
        </h2>

        <p className="text-gray-600 text-center max-w-3xl mx-auto mb-6 leading-relaxed">
          Venkata Sai Traders is a trusted name in the global agro commodities
          market with over <span className="font-semibold text-black">10+ years of industry experience</span>.
          We specialize in sourcing, processing, and exporting premium-quality
          agricultural products to international markets.
        </p>

        <p className="text-gray-600 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          With a deep understanding of agricultural supply chains and global trade
          standards, we consistently deliver products that meet strict quality
          benchmarks. Our mission is to connect farmers to the world while ensuring
          reliability, sustainability, and long-term value for our partners.
        </p>

        {/* STATS */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center mb-12">
          <div>
            <h3 className="text-2xl font-bold text-green-600">10+</h3>
            <p className="text-sm text-gray-600">Years Experience</p>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-green-600">25+</h3>
            <p className="text-sm text-gray-600">Export Countries</p>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-green-600">100+</h3>
            <p className="text-sm text-gray-600">Products</p>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-green-600">500+</h3>
            <p className="text-sm text-gray-600">Happy Clients</p>
          </div>
        </div>

        {/* GRID */}
        <div className="grid md:grid-cols-3 gap-6">

          <div className="p-6 bg-gray-100 rounded-xl text-center hover:shadow-lg transition">
            <h3 className="font-semibold text-lg mb-2">
              🌾 Premium Quality
            </h3>
            <p className="text-sm text-gray-600">
              We follow strict quality control processes at every stage—from sourcing
              to packaging—ensuring our products meet international export standards.
            </p>
          </div>

          <div className="p-6 bg-gray-100 rounded-xl text-center hover:shadow-lg transition">
            <h3 className="font-semibold text-lg mb-2">
              🌍 Global Reach
            </h3>
            <p className="text-sm text-gray-600">
              With a strong global distribution network, we serve clients across
              multiple countries with timely and efficient delivery systems.
            </p>
          </div>

          <div className="p-6 bg-gray-100 rounded-xl text-center hover:shadow-lg transition">
            <h3 className="font-semibold text-lg mb-2">
              🤝 Trusted Partnership
            </h3>
            <p className="text-sm text-gray-600">
              Our commitment to transparency, consistency, and ethical practices
              helps us build long-term relationships with clients worldwide.
            </p>
          </div>

        </div>

        {/* EXTRA CONTENT */}
        <div className="mt-12 text-center max-w-3xl mx-auto">
          <p className="text-gray-600 leading-relaxed mb-4">
            Our product range includes rice, pulses, spices, oil seeds, and a
            variety of agro commodities tailored to meet diverse international
            market requirements.
          </p>

          <p className="text-gray-600 leading-relaxed">
            At Venkata Sai Traders, we are committed to delivering excellence
            from farm to global markets—ensuring quality, trust, and value in
            every shipment.
          </p>
        </div>

      </div>
    </section>
  );
}